/**
 * Polyfill for Object.hasOwn
 * This is required for older browsers (e.g., Safari < 15.4, Chrome < 93)
 * which are still in use but don't support this ES2022 feature.
 */

if (typeof (Object as any).hasOwn !== 'function') {
    Object.defineProperty(Object, 'hasOwn', {
        value: function (object: any, property: PropertyKey) {
            if (object == null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            return Object.prototype.hasOwnProperty.call(Object(object), property);
        },
        configurable: true,
        enumerable: false,
        writable: true,
    });
}

export {};
